import { useAtom } from "jotai";
import { ExtraExpenseAtomsAtom, ExtraExpensesAtom } from "./atoms";
import * as React from "react";
import { ExtraField } from "./extraField";
import { PredefinedField } from "./predefinedField";

import * as strings from "./strings";
import { useNav } from "./useNav";

const {
  back_string,
  next_string,
  step3_addextra_string,
  step3_intro,
  step3_title,
  step3_predefinedxpenses
} = strings;

export function Step3() {
  const { prev, next } = useNav();
  const [extraFieldAtoms, removeExtraField] = useAtom(ExtraExpenseAtomsAtom);
  const [, setExtraFields] = useAtom(ExtraExpensesAtom);

  return (
    <>
      <div className="atc-step-header">
        <p className="at-tagline">Step 3 / 4</p>
        <h2 className="at-title">{step3_title}</h2>
        <div
          className="at-text"
          dangerouslySetInnerHTML={{ __html: step3_intro }}
        />
      </div>
      {step3_predefinedxpenses.map((predefinedgoal, index) => (
        <PredefinedField key={index} {...predefinedgoal} index={index} />
      ))}
      {extraFieldAtoms.map((atom, index) => {
        return (
          <ExtraField
            key={atom.toString()}
            atom={atom}
            index={index + step3_predefinedxpenses.length}
            delete={() => removeExtraField(atom)}
          />
        );
      })}

      <div
        className="at-add-row at-add-row"
        onClick={() =>
          setExtraFields(prevExtraFields => [
            ...prevExtraFields,
            {
              title: `Extra Expense ${extraFieldAtoms.length + 1}`,
              value: null
            }
          ])
        }
      >
        <img
          src={window["mttFinancialAnalysisToolAssets"]?.plusIcon}
          alt="Add row icon"
          className="at-add-row__image"
        />
        <span className="at-add-row__text">{step3_addextra_string}</span>
      </div>
      <div className="atc-button-group atc-button-group--border-top">
        <button className="button white" onClick={prev}>
          {back_string}
        </button>
        <button className="button red" onClick={next}>
          {next_string}
        </button>
      </div>
    </>
  );
}
